<template>
  <modal-auth modal-type="reset" :data="{email: email}">
    <h5 class="text-center">{{$t('resetPassword')}}</h5>
    <br>
    <p class="login-label">{{$t('emailAddressUpper')}} <span style="color: red">*</span></p>
    <input type="email" class="form-control login-input" :placeholder="$t('enterEmail')" v-model="email" required/>
    <div class="text-center">
      <button v-if="!isLoading" class="btn btn-fill btn-danger btn-round btn-sm btn-wd full-width">{{$t('sendResetInstruction')}}</button>
      <sync-loader v-if="isLoading" class="text-center" color="red"></sync-loader>
    </div>
    <div class="remember-block"></div>
    <div class="text-center">
      <google-sign-in-button @click="authGoogle()"/>
    </div>
   </modal-auth>
</template>

<script>
  import ModalAuth from '../components/ModalAuth'
  import GoogleSignInButton from '../components/GoogleSignInButton'
  import { mapGetters } from 'vuex';
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    data() {
      return {
        email: '',
        loopbackBase: process.env.VUE_APP_USTAGE_BASE || 'http://localhost:3000',
      }
    },
    computed: {
      ...mapGetters(['isLoading'])
    },
    methods: {
      authGoogle() {
         window.open(this.loopbackBase + '/auth/google', '_self');
      }
    },
    components: { ModalAuth, GoogleSignInButton, syncLoader }
  }
</script>
